"use strict";
/**
 * Copyright (c) "Neo4j"
 * Neo4j Sweden AB [https://neo4j.com]
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryRequestCodec = exports.QueryResponseCodec = void 0;
var neo4j_driver_core_1 = require("neo4j-driver-core");
var codec_1 = require("./codec");
var QueryResponseCodec = /** @class */ (function () {
    function QueryResponseCodec() {
    }
    QueryResponseCodec.of = function (config, contentType, response) {
        var _a, _b;
        if (isSuccess(response)) {
            if (contentType === codec_1.NEO4J_QUERY_CONTENT_TYPE) {
                return new QuerySuccessResponseCodec(config, response);
            }
            return new QueryFailureResponseCodec((0, neo4j_driver_core_1.newError)("Wrong content-type. Expected \"".concat(codec_1.NEO4J_QUERY_CONTENT_TYPE, "\", but got \"").concat(contentType, "\"."), neo4j_driver_core_1.error.PROTOCOL_ERROR));
        }
        return new QueryFailureResponseCodec(((_a = response.errors) === null || _a === void 0 ? void 0 : _a.length) > 0 ?
            (0, neo4j_driver_core_1.newError)(response.errors[0].message, 
            // TODO: REMOVE THE ?? AND .ERROR WHEN SERVER IS FIXED
            (_b = response.errors[0].code) !== null && _b !== void 0 ? _b : response.errors[0].error) :
            (0, neo4j_driver_core_1.newError)('Server replied an empty error response', neo4j_driver_core_1.error.PROTOCOL_ERROR));
    };
    Object.defineProperty(QueryResponseCodec.prototype, "error", {
        get: function () {
            throw new Error('Not implemented');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QueryResponseCodec.prototype, "keys", {
        get: function () {
            throw new Error('Not implemented');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QueryResponseCodec.prototype, "meta", {
        get: function () {
            throw new Error('Not implemented');
        },
        enumerable: false,
        configurable: true
    });
    QueryResponseCodec.prototype.stream = function () {
        return __generator(this, function (_a) {
            throw new Error('Not implemented');
        });
    };
    return QueryResponseCodec;
}());
exports.QueryResponseCodec = QueryResponseCodec;
var QuerySuccessResponseCodec = /** @class */ (function (_super) {
    __extends(QuerySuccessResponseCodec, _super);
    function QuerySuccessResponseCodec(_config, _response) {
        var _this = _super.call(this) || this;
        _this._config = _config;
        _this._response = _response;
        return _this;
    }
    Object.defineProperty(QuerySuccessResponseCodec.prototype, "error", {
        get: function () {
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuerySuccessResponseCodec.prototype, "keys", {
        get: function () {
            return this._response.data.fields;
        },
        enumerable: false,
        configurable: true
    });
    QuerySuccessResponseCodec.prototype.stream = function () {
        var value;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(this._response.data.values.length > 0)) return [3 /*break*/, 3];
                    value = this._response.data.values.shift();
                    if (!(value != null)) return [3 /*break*/, 2];
                    return [4 /*yield*/, value.map(this._decodeValue.bind(this))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [3 /*break*/, 0];
                case 3: return [2 /*return*/];
            }
        });
    };
    Object.defineProperty(QuerySuccessResponseCodec.prototype, "meta", {
        get: function () {
            return {
                bookmark: this._response.bookmarks,
                stats: this._decodeStats(this._response.counters),
                profile: this._response.profiledQueryPlan != null ?
                    this._decodeProfile(this._response.profiledQueryPlan) : null,
                plan: this._response.queryPlan != null ?
                    this._decodeProfile(this._response.queryPlan) : null,
                notifications: this._response.notifications
            };
        },
        enumerable: false,
        configurable: true
    });
    QuerySuccessResponseCodec.prototype._decodeStats = function (counters) {
        var _this = this;
        return Object.fromEntries(Object.entries(counters)
            .map(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            return [key, typeof value === 'number' ? _this._normalizeInteger((0, neo4j_driver_core_1.int)(value)) : value];
        }));
    };
    QuerySuccessResponseCodec.prototype._decodeProfile = function (queryPlan) {
        var _this = this;
        return Object.fromEntries(Object.entries(queryPlan)
            .map(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            var actualKey = key;
            var actualValue = value;
            switch (key) {
                case 'children':
                    actualValue = value.map(_this._decodeProfile.bind(_this));
                    break;
                case 'arguments':
                    actualKey = 'args';
                    actualValue = Object.fromEntries(Object.entries(value)
                        .map(function (_a) {
                        var _b = __read(_a, 2), k = _b[0], v = _b[1];
                        return [k, _this._decodeValue(v)];
                    }));
                    break;
                case 'records':
                    actualKey = 'rows';
                    break;
                default:
                    break;
            }
            return [actualKey, actualValue];
        }));
    };
    QuerySuccessResponseCodec.prototype._decodeValue = function (value) {
        switch (value.$type) {
            case "Null":
                return null;
            case "Boolean":
                return value._value;
            case "Integer":
                return this._decodeInteger(value._value);
            case "Float":
                return this._decodeFloat(value._value);
            case "String":
                return value._value;
            case "Time":
                return this._decodeTime(value._value);
            case "Date":
                return this._decodeDate(value._value);
            case "LocalTime":
                return this._decodeLocalTime(value._value);
            case "ZonedDateTime":
                return this._decodeZonedDateTime(value._value);
            case "OffsetDateTime":
                return this._decodeOffsetDateTime(value._value);
            case "LocalDateTime":
                return this._decodeLocalDateTime(value._value);
            case "Duration":
                return this._decodeDuration(value._value);
            case "Point":
                return this._decodePoint(value._value);
            case "Base64":
                return this._decodeBase64(value._value);
            case "Map":
                return this._decodeMap(value._value);
            case "List":
                return this._decodeList(value._value);
            case "Node":
                return this._decodeNode(value._value);
            case "Relationship":
                return this._decodeRelationship(value._value);
            case "Path":
                return this._decodePath(value._value);
            default:
                // @ts-expect-error It should never happen
                throw (0, neo4j_driver_core_1.newError)("Unknown type: ".concat(value.$type), neo4j_driver_core_1.error.PROTOCOL_ERROR);
        }
    };
    QuerySuccessResponseCodec.prototype._decodeInteger = function (value) {
        if (this._config.useBigInt === true) {
            return BigInt(value);
        }
        else {
            var integer = (0, neo4j_driver_core_1.int)(value);
            if (this._config.disableLosslessIntegers === true) {
                return integer.toNumber();
            }
            return integer;
        }
    };
    QuerySuccessResponseCodec.prototype._decodeFloat = function (value) {
        return parseFloat(value);
    };
    QuerySuccessResponseCodec.prototype._decodeTime = function (value) {
        var _a, _b, _c, _d, _e, _f;
        // 12:50:35.556+01:00
        // 12:50:35+01:00
        // 12:50:35Z
        var _g = __read(value.split(':'), 4), hourStr = _g[0], minuteString = _g[1], secondNanosecondAndOffsetString = _g[2], offsetMinuteString = _g[3];
        var _h = __read(secondNanosecondAndOffsetString.split('.'), 2), secondStr = _h[0], nanosecondAndOffsetString = _h[1];
        var _j = __read(['0', '0', true, true], 4), nanosecondString = _j[0], offsetHourString = _j[1], isPositive = _j[2], hasOffset = _j[3];
        if (nanosecondAndOffsetString !== undefined) {
            if (nanosecondAndOffsetString.indexOf('+') >= 0) {
                _a = __read(__spreadArray([], __read(nanosecondAndOffsetString.split('+')), false), 2), nanosecondString = _a[0], offsetHourString = _a[1];
            }
            else if (nanosecondAndOffsetString.indexOf('-') >= 0) {
                _b = __read(__spreadArray([], __read(nanosecondAndOffsetString.split('-')), false), 2), nanosecondString = _b[0], offsetHourString = _b[1];
                isPositive = false;
            }
            else if (nanosecondAndOffsetString.indexOf('Z') >= 0) {
                _c = __read(__spreadArray([], __read(nanosecondAndOffsetString.split('Z')), false), 1), nanosecondString = _c[0];
            }
            else {
                hasOffset = false;
                if (nanosecondAndOffsetString.indexOf('[')) {
                    _d = __read(__spreadArray([], __read(nanosecondAndOffsetString.split('[')), false), 1), nanosecondString = _d[0];
                }
            }
        }
        else {
            if (secondStr.indexOf('+') >= 0) {
                _e = __read(__spreadArray([], __read(secondStr.split('+')), false), 2), secondStr = _e[0], offsetHourString = _e[1];
            }
            else if (secondStr.indexOf('-') >= 0) {
                _f = __read(__spreadArray([], __read(secondStr.split('-')), false), 2), secondStr = _f[0], offsetHourString = _f[1];
                isPositive = false;
            }
            else if (secondStr.indexOf('Z') < 0) {
                hasOffset = false;
            }
        }
        secondStr = secondStr.substring(0, 2);
        var nanosecond = (0, neo4j_driver_core_1.int)(nanosecondString.padEnd(9, '0'));
        if (hasOffset) {
            var timeZoneOffsetInSeconds = (0, neo4j_driver_core_1.int)(offsetHourString).multiply(60).add((0, neo4j_driver_core_1.int)(offsetMinuteString !== null && offsetMinuteString !== void 0 ? offsetMinuteString : '0')).multiply(60).multiply(isPositive ? 1 : -1);
            return new neo4j_driver_core_1.Time(this._decodeInteger(hourStr), this._decodeInteger(minuteString), this._decodeInteger(secondStr), this._normalizeInteger(nanosecond), this._normalizeInteger(timeZoneOffsetInSeconds));
        }
        return new neo4j_driver_core_1.LocalTime(this._decodeInteger(hourStr), this._decodeInteger(minuteString), this._decodeInteger(secondStr), this._normalizeInteger(nanosecond));
    };
    QuerySuccessResponseCodec.prototype._decodeDate = function (value) {
        // (+|-)2015-03-26
        // first might be signal or first digit on date
        var first = value[0];
        var _a = __read(value.substring(1).split('-'), 3), yearStr = _a[0], monthStr = _a[1], dayStr = _a[2];
        return new neo4j_driver_core_1.Date(this._decodeInteger(first.concat(yearStr)), this._decodeInteger(monthStr), this._decodeInteger(dayStr));
    };
    QuerySuccessResponseCodec.prototype._decodeLocalTime = function (value) {
        // 12:50:35.556
        var _a = __read(value.split(':'), 3), hourStr = _a[0], minuteString = _a[1], secondNanosecondAndOffsetString = _a[2];
        var _b = __read(secondNanosecondAndOffsetString.split('.'), 2), secondStr = _b[0], nanosecondString = _b[1];
        var nanosecond = (0, neo4j_driver_core_1.int)(nanosecondString.padEnd(9, '0'));
        return new neo4j_driver_core_1.LocalTime(this._decodeInteger(hourStr), this._decodeInteger(minuteString), this._decodeInteger(secondStr), this._normalizeInteger(nanosecond));
    };
    QuerySuccessResponseCodec.prototype._decodeZonedDateTime = function (value) {
        // 2015-11-21T21:40:32.142Z[Antarctica/Troll]
        var _a = __read(value.split('['), 2), dateTimeStr = _a[0], timeZoneIdEndWithAngleBrackets = _a[1];
        var timeZoneId = timeZoneIdEndWithAngleBrackets.slice(0, timeZoneIdEndWithAngleBrackets.length - 1);
        var dateTime = this._decodeOffsetDateTime(dateTimeStr);
        return new neo4j_driver_core_1.DateTime(dateTime.year, dateTime.month, dateTime.day, dateTime.hour, dateTime.minute, dateTime.second, dateTime.nanosecond, (0, neo4j_driver_core_1.isDateTime)(dateTime) ? dateTime.timeZoneOffsetSeconds : undefined, timeZoneId);
    };
    QuerySuccessResponseCodec.prototype._decodeOffsetDateTime = function (value) {
        // 2015-06-24T12:50:35.556+01:00
        var _a = __read(value.split('T'), 2), dateStr = _a[0], timeStr = _a[1];
        var date = this._decodeDate(dateStr);
        var time = this._decodeTime(timeStr);
        if ((0, neo4j_driver_core_1.isTime)(time)) {
            return new neo4j_driver_core_1.DateTime(date.year, date.month, date.day, time.hour, time.minute, time.second, time.nanosecond, time.timeZoneOffsetSeconds);
        }
        return new neo4j_driver_core_1.LocalDateTime(date.year, date.month, date.day, time.hour, time.minute, time.second, time.nanosecond);
    };
    QuerySuccessResponseCodec.prototype._decodeLocalDateTime = function (value) {
        // 2015-06-24T12:50:35.556
        var _a = __read(value.split('T'), 2), dateStr = _a[0], timeStr = _a[1];
        var date = this._decodeDate(dateStr);
        var time = this._decodeLocalTime(timeStr);
        return new neo4j_driver_core_1.LocalDateTime(date.year, date.month, date.day, time.hour, time.minute, time.second, time.nanosecond);
    };
    QuerySuccessResponseCodec.prototype._decodeDuration = function (value) {
        var e_1, _a, _b;
        // P14DT16H12M
        var durationStringWithP = value.slice(1, value.length);
        var month = '0';
        var week = '0';
        var day = '0';
        var second = '0';
        var nanosecond = '0';
        var hour = '0';
        var minute = '0';
        var currentNumber = '';
        var timePart = false;
        try {
            for (var durationStringWithP_1 = __values(durationStringWithP), durationStringWithP_1_1 = durationStringWithP_1.next(); !durationStringWithP_1_1.done; durationStringWithP_1_1 = durationStringWithP_1.next()) {
                var ch = durationStringWithP_1_1.value;
                if (ch >= '0' && ch <= '9' || ch === '.' || ch === ',' || (currentNumber.length === 0 && ch === '-')) {
                    currentNumber = currentNumber + ch;
                }
                else {
                    switch (ch) {
                        case 'M':
                            // minutes
                            if (timePart) {
                                minute = currentNumber;
                                // months
                            }
                            else {
                                month = currentNumber;
                            }
                            break;
                        case 'W':
                            if (timePart) {
                                throw (0, neo4j_driver_core_1.newError)("Duration is not well formatted. Unexpected Duration component ".concat(ch, " in time part"), neo4j_driver_core_1.error.PROTOCOL_ERROR);
                            }
                            week = currentNumber;
                            break;
                        case 'D':
                            if (timePart) {
                                throw (0, neo4j_driver_core_1.newError)("Duration is not well formatted. Unexpected Duration component ".concat(ch, " in time part"), neo4j_driver_core_1.error.PROTOCOL_ERROR);
                            }
                            day = currentNumber;
                            break;
                        case 'S':
                            if (!timePart) {
                                throw (0, neo4j_driver_core_1.newError)("Duration is not well formatted. Unexpected Duration component ".concat(ch, " in date part"), neo4j_driver_core_1.error.PROTOCOL_ERROR);
                            }
                            var nanosecondSeparator = currentNumber.includes(',') ? ',' : '.';
                            _b = __read(currentNumber.split(nanosecondSeparator), 2), second = _b[0], nanosecond = _b[1];
                            break;
                        case 'H':
                            if (!timePart) {
                                throw (0, neo4j_driver_core_1.newError)("Duration is not well formatted. Unexpected Duration component ".concat(ch, " in date part"), neo4j_driver_core_1.error.PROTOCOL_ERROR);
                            }
                            hour = currentNumber;
                            break;
                        case 'T':
                            timePart = true;
                            break;
                        default:
                            throw (0, neo4j_driver_core_1.newError)("Duration is not well formatted. Unexpected Duration component ".concat(ch), neo4j_driver_core_1.error.PROTOCOL_ERROR);
                    }
                    currentNumber = '';
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (durationStringWithP_1_1 && !durationStringWithP_1_1.done && (_a = durationStringWithP_1.return)) _a.call(durationStringWithP_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var secondsInt = (0, neo4j_driver_core_1.int)(hour)
            .multiply(60)
            .add(minute)
            .multiply(60)
            .add(second);
        var dayInt = (0, neo4j_driver_core_1.int)(week)
            .multiply(7)
            .add(day);
        var nanosecondString = nanosecond !== null && nanosecond !== void 0 ? nanosecond : '0';
        return new neo4j_driver_core_1.Duration(this._decodeInteger(month), this._normalizeInteger(dayInt), this._normalizeInteger(secondsInt), this._decodeInteger(nanosecondString.padEnd(9, '0')));
    };
    QuerySuccessResponseCodec.prototype._decodeMap = function (value) {
        var e_2, _a;
        var result = {};
        try {
            for (var _b = __values(Object.keys(value)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var k = _c.value;
                if (Object.prototype.hasOwnProperty.call(value, k)) {
                    result[k] = this._decodeValue(value[k]);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return result;
    };
    QuerySuccessResponseCodec.prototype._decodePoint = function (value) {
        var createProtocolError = function () { return neo4j_driver_core_1.internal.objectUtil.createBrokenObject((0, neo4j_driver_core_1.newError)("Wrong point format. RawValue: ".concat(value), neo4j_driver_core_1.error.PROTOCOL_ERROR), new neo4j_driver_core_1.Point(0, 0, 0)); };
        var splittedOnSeparator = value.split(';');
        if (splittedOnSeparator.length !== 2 || !splittedOnSeparator[0].startsWith('SRID=') ||
            !(splittedOnSeparator[1].startsWith('POINT (') || splittedOnSeparator[1].startsWith('POINT Z ('))) {
            return createProtocolError();
        }
        var _a = __read(splittedOnSeparator[0].split('='), 2), _ = _a[0], sridString = _a[1];
        var srid = this._normalizeInteger((0, neo4j_driver_core_1.int)(sridString));
        var _b = __read(splittedOnSeparator[1].split('('), 2), __ = _b[0], coordinatesString = _b[1];
        var _c = __read(coordinatesString.substring(0, coordinatesString.length - 1).split(" ").filter(function (c) { return c != null; }).map(parseFloat), 3), x = _c[0], y = _c[1], z = _c[2];
        return new neo4j_driver_core_1.Point(srid, x, y, z);
    };
    QuerySuccessResponseCodec.prototype._decodeBase64 = function (value) {
        var binaryString = atob(value);
        // @ts-expect-error See https://developer.mozilla.org/en-US/docs/Glossary/Base64
        return Uint8Array.from(binaryString, function (b) { return b.codePointAt(0); });
    };
    QuerySuccessResponseCodec.prototype._decodeList = function (value) {
        var _this = this;
        return value.map(function (v) { return _this._decodeValue(v); });
    };
    QuerySuccessResponseCodec.prototype._decodeNode = function (value) {
        var _a;
        return new neo4j_driver_core_1.Node(
        // @ts-expect-error identity doesn't return
        undefined, value._labels, this._decodeMap((_a = value._properties) !== null && _a !== void 0 ? _a : {}), value._element_id);
    };
    QuerySuccessResponseCodec.prototype._decodeRelationship = function (value) {
        var _a;
        return new neo4j_driver_core_1.Relationship(
        // @ts-expect-error identity doesn't return
        undefined, undefined, undefined, value._type, this._decodeMap((_a = value._properties) !== null && _a !== void 0 ? _a : {}), value._element_id, value._start_node_element_id, value._end_node_element_id);
    };
    QuerySuccessResponseCodec.prototype._decodePath = function (value) {
        var _this = this;
        var decoded = value.map(function (v) { return _this._decodeValue(v); });
        return new neo4j_driver_core_1.Path(decoded[0], decoded[decoded.length - 1], 
        // @ts-expect-error
        decoded.reduce(function (previous, current) {
            if (previous.acc.length === 2) {
                return {
                    acc: [current], segments: __spreadArray(__spreadArray([], __read(previous.segments), false), [new neo4j_driver_core_1.PathSegment(previous.acc[0], previous.acc[1], current)], false)
                };
            }
            return __assign(__assign({}, previous), { acc: __spreadArray(__spreadArray([], __read(previous.acc), false), [current], false) });
        }, { acc: [], segments: [] }).segments);
    };
    QuerySuccessResponseCodec.prototype._normalizeInteger = function (integer) {
        if (this._config.useBigInt === true) {
            return integer.toBigInt();
        }
        else if (this._config.disableLosslessIntegers === true) {
            return integer.toNumber();
        }
        return integer;
    };
    return QuerySuccessResponseCodec;
}(QueryResponseCodec));
var QueryFailureResponseCodec = /** @class */ (function (_super) {
    __extends(QueryFailureResponseCodec, _super);
    function QueryFailureResponseCodec(_error) {
        var _this = _super.call(this) || this;
        _this._error = _error;
        return _this;
    }
    Object.defineProperty(QueryFailureResponseCodec.prototype, "error", {
        get: function () {
            return this._error;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QueryFailureResponseCodec.prototype, "keys", {
        get: function () {
            throw this._error;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QueryFailureResponseCodec.prototype, "meta", {
        get: function () {
            throw this._error;
        },
        enumerable: false,
        configurable: true
    });
    QueryFailureResponseCodec.prototype.stream = function () {
        throw this._error;
    };
    return QueryFailureResponseCodec;
}(QueryResponseCodec));
var QueryRequestCodec = /** @class */ (function () {
    function QueryRequestCodec(_auth, _query, _parameters, _config) {
        this._auth = _auth;
        this._query = _query;
        this._parameters = _parameters;
        this._config = _config;
    }
    QueryRequestCodec.of = function (auth, query, parameters, config) {
        return new QueryRequestCodec(auth, query, parameters, config);
    };
    Object.defineProperty(QueryRequestCodec.prototype, "contentType", {
        get: function () {
            return codec_1.NEO4J_QUERY_CONTENT_TYPE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QueryRequestCodec.prototype, "accept", {
        get: function () {
            return "".concat(codec_1.NEO4J_QUERY_CONTENT_TYPE, ", application/json");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QueryRequestCodec.prototype, "authorization", {
        get: function () {
            return (0, codec_1.encodeAuthToken)(this._auth);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QueryRequestCodec.prototype, "body", {
        get: function () {
            if (this._body != null) {
                return this._body;
            }
            this._body = __assign({ statement: this._query, includeCounters: true }, (0, codec_1.encodeTransactionBody)(this._config));
            if (this._parameters != null && Object.getOwnPropertyNames(this._parameters).length !== 0) {
                this._body.parameters = this._encodeParameters(this._parameters);
            }
            return this._body;
        },
        enumerable: false,
        configurable: true
    });
    QueryRequestCodec.prototype._encodeParameters = function (parameters) {
        var e_3, _a;
        var encodedParams = {};
        try {
            for (var _b = __values(Object.keys(parameters)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var k = _c.value;
                if (Object.prototype.hasOwnProperty.call(parameters, k)) {
                    encodedParams[k] = this._encodeValue(parameters[k]);
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return encodedParams;
    };
    QueryRequestCodec.prototype._encodeValue = function (value) {
        if (value === null) {
            return { $type: 'Null', _value: null };
        }
        else if (value === true || value === false) {
            return { $type: 'Boolean', _value: value };
        }
        else if (typeof value === 'number') {
            return { $type: 'Float', _value: value.toString() };
        }
        else if (typeof value === 'string') {
            return { $type: 'String', _value: value };
        }
        else if (typeof value === 'bigint') {
            return { $type: 'Integer', _value: value.toString() };
        }
        else if ((0, neo4j_driver_core_1.isInt)(value)) {
            return { $type: 'Integer', _value: value.toString() };
        }
        else if (value instanceof Uint8Array) {
            return { $type: 'Base64', _value: btoa(String.fromCharCode.apply(null, value)) };
        }
        else if (value instanceof Array) {
            return { $type: 'List', _value: value.map(this._encodeValue.bind(this)) };
        }
        else if (isIterable(value)) {
            return this._encodeValue(Array.from(value));
        }
        else if ((0, neo4j_driver_core_1.isPoint)(value)) {
            return {
                $type: 'Point', _value: value.z == null ?
                    "SRID=".concat((0, neo4j_driver_core_1.int)(value.srid).toString(), ";POINT (").concat(value.x, " ").concat(value.y, ")") :
                    "SRID=".concat((0, neo4j_driver_core_1.int)(value.srid).toString(), ";POINT Z (").concat(value.x, " ").concat(value.y, " ").concat(value.z, ")")
            };
        }
        else if ((0, neo4j_driver_core_1.isDuration)(value)) {
            return { $type: 'Duration', _value: value.toString() };
        }
        else if ((0, neo4j_driver_core_1.isLocalTime)(value)) {
            return { $type: 'LocalTime', _value: value.toString() };
        }
        else if ((0, neo4j_driver_core_1.isTime)(value)) {
            return { $type: 'Time', _value: value.toString() };
        }
        else if ((0, neo4j_driver_core_1.isDate)(value)) {
            return { $type: 'Date', _value: value.toString() };
        }
        else if ((0, neo4j_driver_core_1.isLocalDateTime)(value)) {
            return { $type: 'LocalDateTime', _value: value.toString() };
        }
        else if ((0, neo4j_driver_core_1.isDateTime)(value)) {
            if (value.timeZoneOffsetSeconds == null) {
                throw new Error('DateTime objects without "timeZoneOffsetSeconds" property ' +
                    'are prone to bugs related to ambiguous times. For instance, ' +
                    '2022-10-30T2:30:00[Europe/Berlin] could be GMT+1 or GMT+2.');
            }
            if (value.timeZoneId != null) {
                return { $type: 'ZonedDateTime', _value: value.toString() };
            }
            return { $type: 'OffsetDateTime', _value: value.toString() };
        }
        else if ((0, neo4j_driver_core_1.isRelationship)(value) || (0, neo4j_driver_core_1.isNode)(value) || (0, neo4j_driver_core_1.isPath)(value) || (0, neo4j_driver_core_1.isPathSegment)(value) || (0, neo4j_driver_core_1.isUnboundRelationship)(value)) {
            throw (0, neo4j_driver_core_1.newError)('Graph types can not be ingested to the server', neo4j_driver_core_1.error.PROTOCOL_ERROR);
        }
        else if (typeof value === 'object') {
            return { $type: "Map", _value: this._encodeParameters(value) };
        }
        else {
            throw (0, neo4j_driver_core_1.newError)("Unable to convert parameter to http request. Value: ".concat(value), neo4j_driver_core_1.error.PROTOCOL_ERROR);
        }
    };
    return QueryRequestCodec;
}());
exports.QueryRequestCodec = QueryRequestCodec;
function isIterable(obj) {
    if (obj == null) {
        return false;
    }
    // @ts-expect-error
    return typeof obj[Symbol.iterator] === 'function';
}
function isSuccess(obj) {
    if (obj.errors != null) {
        return false;
    }
    return true;
}
